import { useMemo, useState } from 'react';
import { Pie, PieChart } from 'recharts';
import { Text } from '@ui/atoms';
import { useEffect } from 'react';

const FDChart = ({ states }) => {
    const { totalInvested, estimatedReturns, totalValue } = states;

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const pieChartData = useMemo(
        () => [
            {
                name: 'Invested',
                value: Number(totalInvested) || 0,
                fill: '#85e0b1',
            },
            {
                name: 'Returns',
                value: Number(estimatedReturns) || 0,
                fill: '#00a651',
            },
        ],
        [totalInvested, estimatedReturns]
    );
    return (
        <div className="flex flex-col flex-1 gap-10 max-w-[415px] md:max-w-[297px] items-center w-full mx-auto">
            <div className="flex-1">
                {isClient ? (
                    <PieChart width={200} height={200}>
                        <Pie
                            data={pieChartData}
                            cx="50%"
                            cy="50%"
                            outerRadius={90}
                            innerRadius={70}
                            fill="#8884d8"
                            dataKey={null}
                            stroke="none"
                            style={{ outline: 'none' }}
                            startAngle={-270}
                            endAngle={90}
                        />
                    </PieChart>
                ) : null}
            </div>
            <div className="flex flex-col w-full gap-4">
                {/* Total Invested */}
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-4 rounded-full bg-secondary-200" />
                        <Text
                            content={'Total Invested'}
                            className="text-gray-500 p5-medium"
                        />
                    </div>
                    <Text
                        content={`₹${Number(totalInvested || 0).toLocaleString(
                            'en-IN'
                        )}`}
                        className="text-gray-700 p5-semibold"
                    />
                </div>
                {/* Estimated Returns */}
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-4 rounded-full bg-secondary-500" />
                        <Text
                            content={'Est. returns'}
                            className="text-gray-500 p5-medium"
                        />
                    </div>
                    <Text
                        content={`₹${(estimatedReturns || 0).toLocaleString(
                            'en-IN'
                        )}`}
                        className="text-gray-700 p5-semibold"
                    />
                </div>

                <div className="border border-gray-300 border-dashed" />

                <div className="flex items-center justify-between px-2 py-3 border rounded-lg bg-primary-10 border-primary-30">
                    <Text
                        content={'Total Value'}
                        className="text-gray-500 p5-medium"
                    />
                    <Text
                        content={`₹${(totalValue || 0).toLocaleString(
                            'en-IN'
                        )}`}
                        className="text-gray-900 p3-semibold"
                    />
                </div>
            </div>
        </div>
    );
};

export default FDChart;
